import React, { useEffect, useState } from "react";
import OperatingPerformanceIcon from '../../assets/icons/operating-performance.svg';
import CustomTab from '../../components/Common/CustomTab/CustomTab';
// import CustomPagination from "../../components/Common/CustomPagination/CustomPagination";
import Button from '../../components/Button/Button';
import OperatingPerformanceTable from '../../components/Common/CustomTable/ProjectTable/OperatingPerformanceTable';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import DownloadIcon from '../../assets/icons/download-cloud-02.svg';
import Breadcrumb from '../../components/BreadCrumb/BreadCrumb';
import { useDispatch, useSelector } from 'react-redux';
import {
        getMiscellaneousExpenses,
        getNotesOperating,
        getOperatingPerformance,
        getPersonnelPayments,
} from '../../redux/operatingSlice/operatingSlice';
import { getDirectOrderDates } from '../../redux/unitSlice/unitSlice';
import UnitRegionAdminReports from './UnitRegionAdminReports';
import {
        exportExcel,
        getDirectMaterial,
        getEbitda,
        getIndirectMaterial,
        getMiscExpenses,
        getPersonnelPaymentsReport,
        getPower,
        getProfitLoss,
        getRevenue,
} from '../../redux/adminUnitReportSlice/adminUnitReportSlice';

const OperatingPerformanceAdmin = () => {
        const [activeTab, setActiveTab] = useState('0');
        const location = useLocation();
        const [exportExcelFileName, setExportExcelFileName] = useState('');
        const dispatch = useDispatch();
        const searchParams = new URLSearchParams(location.search);
        const mnfUnit = searchParams.get('mnfUnit');
        const unitType = searchParams.get('unitType');

        const {
                operatingPerformanceData,
                notesOperating,
                personnelPayments,
                miscellaneousExpenses,
        } = useSelector((state) => state.operating);

        const { directOrderDates } = useSelector((state) => state.unit);

        const tabData = [
                { label: 'Reports' },
                {
                        label: 'Operating Performance',
                },
                {
                        label: 'Notes to Operating',
                },
                {
                        label: 'Personnel Payments',
                },
                {
                        label: 'Miscellaneous Expenses',
                },
        ];

        useEffect(() => {
                if (activeTab === '0') {
                        dispatch(getDirectMaterial({ mnfUnit }));
                        dispatch(getPersonnelPaymentsReport({ mnfUnit }));
                        dispatch(getMiscExpenses({ mnfUnit }));
                        dispatch(getIndirectMaterial({ mnfUnit }));
                        dispatch(getPower({ mnfUnit }));
                        dispatch(getEbitda({ mnfUnit }));
                        dispatch(getProfitLoss({ mnfUnit }));
                        dispatch(getRevenue({ mnfUnit }));
                }
                if (activeTab === '1') {
                        dispatch(getOperatingPerformance({ page: 1, pageSize: 10, mnfUnit }));
                        dispatch(getDirectOrderDates());
                        setExportExcelFileName('admin_operating_performance');
                }
                if (activeTab === '2') {
                        dispatch(getNotesOperating({ page: 1, pageSize: 10, mnfUnit }));
                        setExportExcelFileName('admin_notes_to_operating');
                }
                if (activeTab === '3') {
                        dispatch(getPersonnelPayments({ page: 1, pageSize: 10, mnfUnit }));
                        setExportExcelFileName('admin_personnel_payments');
                }
                if (activeTab === '4') {
                        dispatch(getMiscellaneousExpenses({ page: 1, pageSize: 10, mnfUnit }));
                        setExportExcelFileName('admin_miscellaneous_expenses');
                }
        }, [activeTab]);

        return (
                <div className="px-5 flex flex-col gap-6 pt-8 pb-20">
                        <div className="flex flex-col px-8 gap-6">
                                <Breadcrumb
                                        queryParams={`unitType=${unitType}&mnfUnit=${mnfUnit}`}
                                />{' '}
                        </div>
                        <div className=" flex justify-between">
                                <div className="flex gap-3">
                                        <img
                                                src={OperatingPerformanceIcon}
                                                alt="OperatingPerformance"
                                        />
                                        <div>
                                                <div className="font-inter font-semibold text-[24px] leading-[32px] tracking-[0%] text-[#101828]">
                                                        Operating Results
                                                </div>
                                        </div>
                                </div>
                        </div>
                        <div className="flex justify-between items-center">
                                <div className="text-gray-500 text-sm flex justify-start">
                                        * All figures are in Rupees (in lakhs).
                                </div>
                                {activeTab !== '0' && (
                                        <div className="flex gap-[12px]">
                                                <Button
                                                        text="Export report"
                                                        icon={DownloadIcon}
                                                        onClick={() =>
                                                                dispatch(
                                                                        exportExcel({
                                                                                key: exportExcelFileName,
                                                                        }),
                                                                )
                                                        }
                                                />
                                        </div>
                                )}
                        </div>
                        <div>
                                <CustomTab
                                        tabItems={tabData}
                                        activeTab={activeTab}
                                        setActiveTab={setActiveTab}
                                />
                        </div>
                        {/* Table */}
                        <div className="pb-4">
                                {activeTab === '0' && (
                                        <div>
                                                <UnitRegionAdminReports />
                                        </div>
                                )}
                                {activeTab === '1' && (
                                        <div>
                                                <OperatingPerformanceTable
                                                        tableData={operatingPerformanceData}
                                                        dates={directOrderDates}
                                                />
                                        </div>
                                )}
                                {activeTab === '2' && (
                                        <div>
                                                <OperatingPerformanceTable
                                                        tableData={notesOperating}
                                                        dates={directOrderDates}
                                                />
                                        </div>
                                )}
                                {activeTab === '3' && (
                                        <div>
                                                <OperatingPerformanceTable
                                                        tableData={personnelPayments}
                                                        dates={directOrderDates}
                                                />
                                        </div>
                                )}
                                {activeTab === '4' && (
                                        <div>
                                                <OperatingPerformanceTable
                                                        tableData={miscellaneousExpenses}
                                                        dates={directOrderDates}
                                                />
                                        </div>
                                )}
                        </div>
                        {/* Pagination */}
                        {/* <div className="mb-8">
        <CustomPagination
          totalItems={30}
          pageSize={pageSize}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div> */}
                </div>
        );
};

export default OperatingPerformanceAdmin;
